import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { ApplicationState } from "../../../../../../../store";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { getEvidenceAssessments, getEvidenceInDataPeriod, openAddAssessmentModal, resetRedirectToSetGoal } from "../../../../../../../store/onboarding/actions";
import {
  EvidenceAssessment,
  EvidencePeriodData,
  EvidenceType,
  Measurement,
} from "../../../../../../../store/onboarding/types";
import LoadingIndicator from "../../../../LoadingIndicator";
import {
  GoalTypes,
  InterventionGroup,
  StudentGoal,
} from "../../../../../../../store/onboarding/cases/types";
import EvidenceTable from "../../../../second-step/evidence-tab/EvidenceTable";
import App from "../../../../../../../App";
import _ from "lodash";
import { showConfirmDialog } from "../../../../../../../store/confirm-dialog/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup, OverlayTrigger, Popover } from "react-bootstrap";
import { UserAssignmentRole } from "../../../../../../../store/auth/types";
import { sendParamInEvidenceTable } from "../../../../../../../store/onboarding/cases/actions";
import DataTablePagination from "../../../../second-step/evidence-tab/dataTablePagination";

type PropsFromState = {
  studentGoal?: StudentGoal;
  evidenceAssessments: Array<EvidenceAssessment>;
  evidenceAssessment?: EvidenceAssessment;
  isLoading: {
    getEvidenceAssessments: boolean;
  };
  isRedirectToSetGoal?: boolean;
  interventionGroup: InterventionGroup;
  setMissedGoal?: boolean;
};
type DispatchProps = {
  getEvidenceAssessments: (type?: GoalTypes) => any;
  openAddAssessmentModal: (isNewProgressMonitoring?: boolean) => any;
  resetRedirectToSetGoal: () => any;
};
type OwnProps = {
  hasBehavioralGoalType?: boolean;
  onBackClick: () => any;
  onNextClick: (selectedMeasurement: Measurement) => any;
  isDiffMeasurement?: boolean;
  setIsDiffMeasurement?: (isDiffMeasurement: boolean) => any
  isStudentGoalExist?: boolean;
  selectedBrsMeasurement?: Measurement;
  isStudentSecondaryGoalExist?: boolean;
};
type Props = OwnProps & PropsFromState & DispatchProps;

const BRSInput: FunctionComponent<Props> = (props) => {
  const { 
    evidenceAssessments, 
    hasBehavioralGoalType, 
    setIsDiffMeasurement, 
    isStudentGoalExist,
    isStudentSecondaryGoalExist,
    isRedirectToSetGoal, 
    evidenceAssessment,
    selectedBrsMeasurement,
    interventionGroup,
    setMissedGoal
  } = props;
  
  const dispatch = useDispatch();
  const [searchFilter, setSearchFilter] = useState<string>("");

  const selectedInterventionGroup = useSelector<
    ApplicationState,
    InterventionGroup | undefined
  >((s) => s.cases.selectedInterventionGroup);

  const [selectedMeasurement, setSelectedMeasurement] = useState<
    Measurement | undefined
  >(undefined);

  useEffect(() => {
    props.getEvidenceAssessments(
      selectedInterventionGroup?.goal_type == GoalTypes.BEHAVIOR
      ? GoalTypes.BEHAVIOR
      : GoalTypes.ACADEMIC
    );
  }, []);

  const measurements: Array<Measurement> = useMemo(
    () =>
      props.evidenceAssessments.reduce(
        (pV, cV) => [...pV, ...cV.measurements],
        [] as Array<Measurement>
      ),
    [props.evidenceAssessments]
  );

  const existingGoalofStudent = useMemo(() => {
    return interventionGroup.student_goals
    .filter((sg) => !sg.archived && (sg.student.id == props.studentGoal?.student.id))
    .map((sg) => sg.measurement.id);
  },[props.studentGoal])

  useEffect(() => {
    if(selectedBrsMeasurement) {
      setSelectedMeasurement(selectedBrsMeasurement);
    } else if (props.studentGoal?.id) {
      setSelectedMeasurement(
        measurements.find((m) => m.id === props.studentGoal!.measurement.id)
      );
    }
  }, [props.studentGoal, measurements, selectedBrsMeasurement]);


  useEffect(() => {
    if(isRedirectToSetGoal && evidenceAssessment?.measurements?.length) {
      props.onNextClick(evidenceAssessment?.measurements[0]);
      handleBarsAssessmentsSelect(evidenceAssessment?.measurements[0])
      props.resetRedirectToSetGoal();
    }
  },[isRedirectToSetGoal, evidenceAssessment])

  useEffect(() => {
      if(selectedInterventionGroup) {
        dispatch(sendParamInEvidenceTable(true));
        dispatch(getEvidenceInDataPeriod());
      }
    }, [])

  const handleBarsAssessmentsSelect = (measurement: Measurement) => () => {
     let isDifferMeasureExist:boolean = false;
     if(props.studentGoal && props.studentGoal!.measurement)  {
       isDifferMeasureExist = props.studentGoal!.measurement?.id !== measurement.id;
      } else {
        isDifferMeasureExist = !!selectedInterventionGroup?.student_goals
        .filter((stdGoal) => !stdGoal.archived)
        .filter((stdGoal) => stdGoal.is_primary_goal)
        .some((sg) => sg.measurement.id != measurement.id);
      }
      const singleStdWithGoal = 
        selectedInterventionGroup?.students
          .filter((std) => selectedInterventionGroup?.student_goals
            .some((sg) => (std.id == sg.student.id) && !sg.archived));

      if (singleStdWithGoal!.length == 1) {
        if(!selectedInterventionGroup?.finished) {
          isDifferMeasureExist = false
          setIsDiffMeasurement!(false);
        }
      }


    if(isDifferMeasureExist && props.studentGoal?.is_primary_goal) {
      dispatch(
        showConfirmDialog({
          onConfirm: () => {
            setIsDiffMeasurement!(true);
            setSelectedMeasurement(measurement);
            props.onNextClick(measurement!)
          },
          centered: true,
          title: "Change Measure",
          text: (
            <>
            {props.studentGoal && props.studentGoal!.id ? 
            <>
              <p className="font-weight-bold mb-0 text-center">{`Are you sure you want to change the measure for the primary goal?`}</p>
              <p className="font-weight-bold text-left mb-1 ml-4">{`This will:`}</p>
            </>
              :
              <p className="font-weight-bold text-center">{`Adding a different measurement tool than other students in the group will:`}</p>
            }
             <ul className="text-left">
              {selectedInterventionGroup?.finished ? <li>Archive the current group.</li> : ''}
              {!selectedInterventionGroup?.finished ? <li>Discard and move group to Recommendations.</li> : ''}
              <li>Create a new group with the same students.</li>
              <li>Not move student goals to the new group.</li>
            </ul>
            <p className="mb-0">Click <strong>CONFIRM</strong> to create the new group and set goal(s). </p>
            </>
          ),
          confirmButtonText: "Confirm",
        })
      );
    } else {
      setSelectedMeasurement(measurement);
    }
  };

  const evidenceData = useSelector<
    ApplicationState,
    EvidencePeriodData | undefined
  >((s) => s.onboarding.evidencePeriodData);

  const assessmentsMeasurementsIdsForGroup = useMemo(() => {
    if (evidenceData && selectedInterventionGroup) {
      return evidenceData.evidence_column_groups
        .filter(
          (ecg) =>
            ecg.assessment &&
            ecg.evidence_columns.some((ec) =>
              ec.student_entries.some((se) =>
                selectedInterventionGroup.students.some(
                  (s) => s.id === se.student_id
                )
              )
            )
        )
        .map((ecg) => ({
          assessmentId: ecg.assessment.id,
          measurementsIds: ecg.evidence_columns
            .filter((ec) => ec.evidence_type != EvidenceType.BehaviorScreener)
            .reduce<number[]>((pV, ec) => {
            return ec.student_entries.some((se) =>
              selectedInterventionGroup.students.some(
                (s) => s.id === se.student_id
              )
            )
              ? [...pV, ec.measurement.id!]
              : pV;
          }, []),
        }))
        .reverse();
    }

    return [];
  }, [selectedInterventionGroup, evidenceData]);

  const compareAssessments = useCallback(
    (a: EvidenceAssessment, b: EvidenceAssessment) => {
      const aIndex = assessmentsMeasurementsIdsForGroup.findIndex(
        (predicate) => predicate.assessmentId === a.id
      );
      const bIndex = assessmentsMeasurementsIdsForGroup.findIndex(
        (predicate) => predicate.assessmentId === b.id
      );

      if (aIndex === -1 && bIndex === -1) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        return 0;
      } else {
        return bIndex - aIndex;
      }
    },
    [assessmentsMeasurementsIdsForGroup]
  );

  const compareMeasurement = useCallback(
    (ids: number[]) => (a: Measurement, b: Measurement) => {
      const aIndex = ids.indexOf(a.id!);
      const bIndex = ids.indexOf(b.id!);

      if (aIndex === -1 && bIndex === -1) {
        if (a.display_name > b.display_name) {
          return 1;
        }
        if (a.display_name < b.display_name) {
          return -1;
        }
        return 0;
      } else {
        return bIndex - aIndex;
      }
    },
    []
  );

  const handleSearchFilterChange = (event: React.ChangeEvent<any>) => {
    event.preventDefault();
    const { value } = event.target as HTMLInputElement;
    setSearchFilter(value.toLowerCase());
  };

  const sortedEvidenceAssessments = useMemo(() => {
    return evidenceAssessments
      .sort(compareAssessments)
      .filter((ea) => ea.measurements?.length)
      .map((ea) => {
        const ids =
          assessmentsMeasurementsIdsForGroup
            .find((a) => a.assessmentId === ea.id)
            ?.measurementsIds.slice()
            .reverse() ?? [];

        const sorted = ea.measurements.sort(compareMeasurement(ids));

        return {
          ...ea,
          measurements: sorted,
        };
      });
  }, [
    evidenceAssessments,
    assessmentsMeasurementsIdsForGroup,
    compareMeasurement,
  ]);

  const hasResults = useMemo(() => {
    const normalizedSearch = searchFilter.trim().toLowerCase();
    return sortedEvidenceAssessments.some((ev) =>
      ev.measurements
        .filter((measurement) => {
          if (!normalizedSearch) return true;

          return (
            measurement.display_name
              .toLowerCase()
              .includes(normalizedSearch) ||
            ev.name.toLowerCase().includes(normalizedSearch) ||
            (ev.owner &&
              `${ev.owner.first_name} ${ev.owner.last_name}`
                .toLowerCase()
                .includes(normalizedSearch))
          );
        })
        .filter((measure) =>
          existingGoalofStudent.length
            ? !existingGoalofStudent.includes(measure.id)
            : true
        )
        .filter((measurement) =>
          setMissedGoal
            ? interventionGroup.student_goals.some(
                (sg) =>
                  !sg.archived &&
                  sg.measurement.id === measurement.id
              )
            : true
        ).length > 0
    );
  }, [sortedEvidenceAssessments, existingGoalofStudent, setMissedGoal, interventionGroup, searchFilter]);


  return (
    <>
      <h2 className="mb-0 font-weight-bold">
        {hasBehavioralGoalType ? "Behavior Rating Scales" : "Assessments"}
      </h2>
      <h4 className="mb-2">
        Select a {hasBehavioralGoalType && "Behavior Rating Scale"} assessment
        from the list of recommended assessments below. Each of these
        assessments is backed by evidence that shows they are effective measures
        of your selected target behavior(s)/skill(s).
      </h4>

      {selectedInterventionGroup && (
        <div className="small-evidence-table-container mb-2">
          <EvidenceTable
            interventionGroup={selectedInterventionGroup}
            isReadonly
            minimal
            //fromSetGoalModal
          />
          <DataTablePagination/>
        </div>
      )}
      <div className="row my-2">
        <div className="col-7 d-flex align-items-center">
          <h4 data-cy="selected-assessment">
            <strong>Selected Measurement:</strong>{" "}
            {selectedMeasurement ? (
              selectedMeasurement.display_name
            ) : (
              <i data-cy="none">None selected</i>
            )}
          </h4>
        </div>
        <div className="col-5 d-flex justify-content-end">
          <InputGroup className={`filterSearchDesktop`} style={{width: "300px"}}>
            <InputGroup.Prepend>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchFilter}
              onChange={handleSearchFilterChange}
              className="filterSearchHeight"
            />
          </InputGroup>
        </div>
      </div>
      <div style={{ height: 300, overflowY: "auto", scrollbarWidth: "thin" }}>
        {props.isLoading.getEvidenceAssessments ? (
          <LoadingIndicator type="table" rows={10} columns={3} />
        ) : (
          <table data-cy="assessments-table" className="BRSTempTable">
            <thead>
              <tr>
                <th>ASSESSMENT</th>
                <th>MEASUREMENT</th>
                <th>CREATED BY</th>
              </tr>
            </thead>
            <tbody>
              {!hasResults ? (
                <tr>
                  <td colSpan={3} className="text-center py-3">
                    No matching data found.
                  </td>
                </tr>
              ) : (
                sortedEvidenceAssessments.map((ev) => {
                  const normalizedSearch = searchFilter.trim().toLowerCase();

                  const filteredMeasurements = ev.measurements
                    .filter((measurement) => {
                      if (!normalizedSearch) return true;

                      return (
                        measurement.display_name
                          .toLowerCase()
                          .includes(normalizedSearch) ||
                        ev.name.toLowerCase().includes(normalizedSearch) ||
                        (ev.owner &&
                          `${ev.owner.first_name} ${ev.owner.last_name}`
                            .toLowerCase()
                            .includes(normalizedSearch))
                      );
                    })
                    .filter((measure) =>
                      existingGoalofStudent.length
                        ? !existingGoalofStudent.includes(measure.id)
                        : true
                    )
                    .filter((measurement) =>
                      setMissedGoal
                        ? interventionGroup.student_goals.some(
                            (sg) =>
                              !sg.archived &&
                              sg.measurement.id === measurement.id
                          )
                        : true
                    );

                  // Skip assessments with no matching measurements
                  if (filteredMeasurements.length === 0) {
                    return null;
                  }

                  return (
                    <React.Fragment key={ev.id}>
                      {filteredMeasurements.map((measurement) => {
                        if (setMissedGoal) {
                          setTimeout(() => {
                            document
                              .getElementById(`measurement_${measurement.id}`)
                              ?.click();
                          }, 1);
                        }

                        return (
                          <tr
                            className={
                              selectedMeasurement &&
                              measurement.id === selectedMeasurement.id
                                ? "selectedAssessment"
                                : ""
                            }
                            key={measurement.id}
                            onClick={handleBarsAssessmentsSelect(measurement)}
                            id={`measurement_${measurement.id}`}
                          >
                            <td className="font-weight-bold">
                              <span
                                className="text-truncate"
                                title={ev.name}
                                style={{ maxWidth: "300px" }}
                              >
                                {ev.name}
                              </span>
                            </td>

                            <td data-cy="assessment-measurement">
                              <span
                                className="text-truncate"
                                title={measurement.display_name}
                                style={{ maxWidth: "300px" }}
                              >
                                {measurement.display_name}
                              </span>
                            </td>

                            <td>
                              {ev.owner ? (
                                <div className="d-flex">
                                  <span
                                    className="text-truncate"
                                    title={`${ev.owner.first_name} ${ev.owner.last_name}`}
                                    style={{ maxWidth: "300px" }}
                                  >
                                    {`${ev.owner.first_name} ${ev.owner.last_name}`}
                                  </span>
                                  <span>
                                    {ev.owner.current_role ===
                                    UserAssignmentRole.DISTRICT_OWNER
                                      ? "(District Admin)"
                                      : ""}
                                  </span>
                                </div>
                              ) : ev.is_system_assessment ? (
                                "ReadyCoach"
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
        )}
      </div>
      {!isStudentGoalExist ? <p className="my-3">
        <FontAwesomeIcon icon={faInfoCircle} /> You are setting the first goal for the student(s).
          To set additional goals, go to Manage in the Group Workspace.
      </p>: ''}
      <hr />
      {isStudentSecondaryGoalExist ?
        <div className="modalActions">
          <OverlayTrigger
            overlay={
              <Popover id="progressMonitorAssessment">
                <Popover.Content>If you do not see your assessment listed above, click here to add.</Popover.Content>
              </Popover>
            }
          >
          <button
            data-cy="next-btn"
            className="blueBtnSm"
            onClick={() => props.openAddAssessmentModal(true)}
          >
            Add new progress monitoring assessment
          </button>
          </OverlayTrigger>
          <button
            data-cy="next-btn"
            className="blueBtnSm"
            onClick={() => props.onNextClick(selectedMeasurement!)}
            disabled={!selectedMeasurement}
          >
            Next
          </button>
        </div>
      : <div className="d-flex justify-content-end">
         <button
            data-cy="next-btn"
            className="blueBtnSm"
            onClick={() => props.onNextClick(selectedMeasurement!)}
            disabled={!selectedMeasurement}
          >
            Next
          </button>
        </div>
      }
    </>
  );
};

const mapStateToProps = ({
  onboarding,
  cases,
}: ApplicationState): PropsFromState => {
  return {
    studentGoal: cases.selectedStudentGoal,
    interventionGroup: cases.selectedInterventionGroup!,
    evidenceAssessments: onboarding.evidenceAssessments,
    evidenceAssessment: onboarding.evidenceAssessment,
    isRedirectToSetGoal: onboarding.modalsState.isRedirectToSetGoal,
    setMissedGoal: cases.modalsState.setMissedGoal,
    isLoading: {
      getEvidenceAssessments: onboarding.isLoading.getEvidenceAssessments,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      getEvidenceAssessments: getEvidenceAssessments,
      openAddAssessmentModal: openAddAssessmentModal,
      resetRedirectToSetGoal: resetRedirectToSetGoal
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BRSInput);
